export default "__VITE_ASSET__CwPKQklZ__"